import Loader from '@/components/loader';
import { lazy, Suspense } from 'react';

const Header = lazy(() => import('@/components/header'));
const Footer = lazy(() => import('@/components/footer'));

export default function VisitorLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <Suspense fallback={<Loader />}>
            <div className="light flex min-h-svh flex-col">
                <Header />
                <main className="flex flex-1 flex-col justify-center">
                    {children}
                </main>
                <Footer />
            </div>
        </Suspense>
    );
}
